import React, { useState, useEffect } from 'react';
import { Scanner } from '@yudiel/react-qr-scanner';
import { Box, Typography, Button, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; // Import close icon

const QrScanner = (props) => {
  const { onChange, questionTitle, optionalValue, disabled } = props; // Accept optionalValue as a prop
  const [scannedValue, setScannedValue] = useState(optionalValue || ""); // Initialize with optional value
  const [open, setOpen] = useState(false); // State to control modal open/close

  const handleScan = (result) => {
    if (result && result.length > 0) {
      const data = result[0].rawValue;
      setScannedValue(data);
      onChange(data); // Update the scanned value
      setOpen(false); // Close modal after scanning
    }
  };

  const handleError = (err) => {
    console.error(err);
  };

  const handleOpen = () => setOpen(true); // Open modal
  const handleClose = () => setOpen(false); // Close modal

  useEffect(() => {
    const checkCameraPermissions = async () => {

      try {
        const permissionStatus = await navigator.permissions.query({ name: "camera" });
        if (permissionStatus.state === "granted" || permissionStatus.state === "prompt") {
        } else {
          throw new Error("Camera permission is denied. Please allow camera access in your browser settings.", "error", 4000);
        }
      } catch (error) {
        throw new Error("An error occurred while checking camera permissions.", "error", 4000);
      }
    };

    checkCameraPermissions();
  }, []);

  return (
    <Box sx={{ textAlign: 'left', margin: '20px' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
        <Typography variant="h6" sx={{ marginRight: '10px' }}>
          {questionTitle}
        </Typography>
        <Button 
          disabled={disabled}
          variant="contained" 
          onClick={handleOpen} 
        >
          {scannedValue ? "Rescan QR" : "Open Scanner"} {/* Change button text based on scanned value */}
        </Button>
      </Box>

      {scannedValue && (
        <Typography variant="body1" sx={{ marginTop: '10px' }}>
          Scanned Value: {scannedValue}
        </Typography>
      )}

      <Modal open={open} onClose={handleClose}>
        <Box sx={{ 
          width: 400, // Set width for the modal
          bgcolor: 'background.paper', 
          p: 4, 
          borderRadius: 2, 
          boxShadow: 24,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)', // Center the modal
          textAlign: 'center'
        }}>
          <IconButton 
            onClick={handleClose} 
            sx={{ position: 'absolute', top: 10, right: 10 }} // Position close button
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6">QR Scanner</Typography>
          <Scanner
            onScan={handleScan}
            onError={handleError}
            style={{ width: '100%', height: 'auto' }}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default QrScanner;